import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromFilesResolution from './files-resolution.reducer';

export const selectFilesResolutionState = createFeatureSelector<fromFilesResolution.State>(
  'filesResolution',
);
export const selectAllFilesResolution = createSelector(
  selectFilesResolutionState,
  fromFilesResolution.selectAllFilesResolution,
);

export const selectTotalPixelsAmount = createSelector(selectAllFilesResolution, (all) =>
  all.reduce((acc, fr) => (fr.processed ? acc + fr.width * fr.height : acc), 0),
);

export const selectIsResolutionDataProcessed = createSelector(selectAllFilesResolution, (all) =>
  all.every((fr) => fr.processed),
);

export const selectProcessedResolutionDataCount = createSelector(
  selectAllFilesResolution,
  (all) => all.filter((data) => data.processed).length,
);

export const selectAllResolutionDataCount = createSelector(
  selectFilesResolutionState,
  fromFilesResolution.selectTotalFilesResolution,
);
